import { useEffect } from 'react';
import { addCoreQaToolboxSpaceRefreshListener, appendCoreQaToolboxBootstrap, isCoreQaToolboxEnvironment } from './environment';
declare const process: {
  env: {
    NEXT_PUBLIC_STAGE?: string;
  };
};
type CoreQaToolboxLoaderProps = {
  currentMapHashId?: string;
  routeMapHashId?: string;
};
export function CoreQaToolboxLoader({
  currentMapHashId,
  routeMapHashId
}: CoreQaToolboxLoaderProps): null {
  useEffect(() => {
    if (!isCoreQaToolboxEnvironment(process.env.NEXT_PUBLIC_STAGE, window.location.hostname)) {
      return;
    }
    const removeSpaceRefreshListener = addCoreQaToolboxSpaceRefreshListener(window, () => window.location.reload());
    try {
      const mapHashId = typeof routeMapHashId === 'string' && routeMapHashId.length > 0 ? routeMapHashId : currentMapHashId;
      if (mapHashId) {
        window.__ZEP_QA_CURRENT_MAP_HASH_ID__ = mapHashId;
      } else {
        delete window.__ZEP_QA_CURRENT_MAP_HASH_ID__;
      }
      appendCoreQaToolboxBootstrap(document, window.location.pathname);
    } catch {
      // Toolbox loading must never affect the product runtime.
    }
    return removeSpaceRefreshListener;
  }, [currentMapHashId, routeMapHashId]);
  return null;
}
declare global {
  interface Window {
    __ZEP_QA_CURRENT_MAP_HASH_ID__?: string;
  }
}